/**
 * Shared types and constants for the image attachment system.
 */

export const API_URL =
  import.meta.env.VITE_API_URL ?? 'https://api.caliuapp.com'

export interface AttachmentResponse {
  attachment: {
    id: string
    filename: string
    content_type: string
    size_bytes: number
    r2_key: string
    created_at: string
  }
}

/** Maximum file size accepted by the attachments API (100 MB). Keep in sync with the worker. */
export const MAX_FILE_SIZE = 100 * 1024 * 1024
